import { http } from '../api/client';
import { API_BASE } from '../auth/identity';

const baseURL = API_BASE.replace(/\/dash$/, '') + '/provider';
const portal = (vertical: 'telehealth' | 'medspa') => API_BASE.replace(/\/dash$/, '') + `/portal/${vertical}`;

export interface ProviderItem {
  id: string;
  item_kind: string;
  state_code: string;
  due_date: string | null;
  answer: 'yes' | 'no' | 'not_sure' | null;
  answered_at: string | null;
}

export const providerApi = {
  mine: async () => (await http.get<{ customer_ids: string[] }>('/mine', { baseURL })).data,
  items: async (cid: string) => (await http.get<{ person_name: string; vertical: string; items: ProviderItem[]; documents: Array<{ id: string; item_id: string; received_at: string | null }> }>(`/customers/${cid}/items`, { baseURL })).data,
  answer: async (cid: string, id: string, answer: 'yes' | 'no' | 'not_sure') =>
    (await http.post(`/customers/${cid}/items/${id}/answer`, { answer }, { baseURL })).data,
  answerAll: async (cid: string) =>
    (await http.post(`/customers/${cid}/answer-all`, {}, { baseURL })).data,
  documentForm: async (cid: string, itemId: string, file: File) =>
    (await http.post<{ document_id: string; url: string; fields: Record<string, string> }>(
      `/customers/${cid}/items/${itemId}/documents`, { content_type: file.type, size_bytes: file.size }, { baseURL })).data,
  documentComplete: async (cid: string, documentId: string) =>
    (await http.post(`/customers/${cid}/documents/${documentId}/complete`, {}, { baseURL })).data,
  ownDocumentLink: async (cid: string, documentId: string) =>
    (await http.get<{ url: string }>(`/customers/${cid}/documents/${documentId}`, { baseURL })).data,
  ask: async (vertical: 'telehealth' | 'medspa', cid: string, body: {
    person_id: string; email: string; kind: string; state_codes: string[]; due_date: string | null;
  }) => (await http.post(`/customers/${cid}/provider-requests/ask`, body, { baseURL: portal(vertical) })).data,
  list: async (vertical: 'telehealth' | 'medspa', cid: string, kind: 'all' | 'credential' | 'other' = 'all', offset = 0) =>
    (await http.get<{ items: Array<{ id: string; person_id: string | null; state_code: string | null; item_key: string | null; item_label: string | null; email: string | null; assignee_user_id: string; invitation_id: string | null; revoked_at: string | null; due_date: string | null; answer: string | null; completed_at: string | null; document_count: number; document_ids: string[] }>; has_more: boolean }>(
      `/customers/${cid}/provider-requests`, { baseURL: portal(vertical), params: { kind, offset } })).data,
  revoke: async (vertical: 'telehealth' | 'medspa', cid: string, invitationId: string) =>
    (await http.post(`/customers/${cid}/provider-requests/${invitationId}/revoke`, {}, { baseURL: portal(vertical) })).data,
  assign: async (vertical: 'telehealth' | 'medspa', cid: string, body: {
    item_kind: string; person_id?: string; state_code?: string; item_key?: string; item_label?: string;
    assignee_email: string; due_date: string | null;
  }) => (await http.post(`/customers/${cid}/provider-requests/assign`, body, { baseURL: portal(vertical) })).data,
  complete: async (vertical: 'telehealth' | 'medspa', cid: string, itemId: string) =>
    (await http.post(`/customers/${cid}/provider-requests/items/${itemId}/complete`, {}, { baseURL: portal(vertical) })).data,
  documentLink: async (vertical: 'telehealth' | 'medspa', cid: string, documentId: string) =>
    (await http.get<{ url: string }>(`/customers/${cid}/provider-requests/documents/${documentId}`, { baseURL: portal(vertical) })).data,
};
